import React from 'react';
import ReactDOM from 'react-dom';
import { FCThemeProvider, styled } from '@fctg-ds/theme';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Paper from '@mui/material/Paper';
import ListItemText from '@mui/material/ListItemText';

import ResultsPage from './components/ResultsPage';
import ProductPage from './components/ProductPage';
import ImageGalleryModal from './components/ImageGalleryModal';
import InclusionsList from './components/InclusionsList';
import StaysDetailDrawer from './components/StayDetailDrawer';
import StaysDetailModal from './components/StayDetailModal';
import StaySummary from './components/StaySummary';
import StayAmenities from './components/StayAmenities';
import Filters from './components/Filters';
import RoomDetails from './components/RoomDetails';
import StayDetailsView from './components/StayDetailsView';
import { MenuList } from '@mui/material';

const elem = document.getElementById('app');
const reactElem = elem?.getAttribute('data-elem');

enum MenuItemType {
  Stay,
  Public,
  Shared,
}

export const MappedComponents = {
  'results-page': { component: <ResultsPage />, label: 'Results Page', type: MenuItemType.Public },
  'product-page': { component: <ProductPage />, label: 'Product Page', type: MenuItemType.Public },
  'stay-summary': { component: <StaySummary />, label: 'Stay Summary', type: MenuItemType.Public },
  'stay-amenities': { component: <StayAmenities />, label: 'Stay Amenities', type: MenuItemType.Public },
  'image-gallery-modal': { component: <ImageGalleryModal />, label: 'Image Gallery Modal', type: MenuItemType.Public },
  'stays-detail-drawer': { component: <StaysDetailDrawer />, label: 'Stays Detail Drawer', type: MenuItemType.Public },
  'stays-detail-modal': { component: <StaysDetailModal />, label: 'Stays Detail Modal', type: MenuItemType.Public },
  'inclusions-list': { component: <InclusionsList />, label: 'Inclusions List', type: MenuItemType.Public },
  'room-details': { component: <RoomDetails />, label: 'Room Details', type: MenuItemType.Public },
  'stay-details-view': { component: <StayDetailsView />, label: 'Stay Details View', type: MenuItemType.Public },
  filters: { component: <Filters />, label: 'Filters', type: MenuItemType.Stay },
};

const SContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '100px',
  padding: '0px 20px 100px 20px,',
});
const App = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <FCThemeProvider>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton onClick={handleMenu} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <Paper sx={{ width: 320, maxWidth: '100%' }}>
              <MenuList
                sx={{
                  root: {
                    paddingTop: '0px',
                    paddingBottom: '0px',
                  },
                }}
              >
                {Object.keys(MappedComponents)
                  .filter((page) => [MenuItemType.Shared, MenuItemType.Stay].includes(MappedComponents[page].type))
                  .map((page) => (
                    <MenuItem onClick={() => (window.location.href = `/${page}.html`)}>
                      <ListItemText>{MappedComponents[page].label}</ListItemText>
                    </MenuItem>
                  ))}
              </MenuList>
            </Paper>
          </Menu>
          <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
            Stays Component Library
          </Typography>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {Object.keys(MappedComponents)
              .filter((page) => MappedComponents[page].type === MenuItemType.Public)
              .map((page) => (
                <Button
                  key={page}
                  href={`/${page}.html`}
                  sx={{
                    mx: 2,
                    my: 2,
                    color: 'black',
                    display: 'block',
                    background: 'lightgrey',
                  }}
                >
                  <Typography align="center" fontSize={12}>
                    {MappedComponents[page].label}
                  </Typography>
                </Button>
              ))}
          </Box>
        </Toolbar>
      </AppBar>
      <SContainer>{reactElem && MappedComponents[reactElem]?.component}</SContainer>
    </FCThemeProvider>
  );
};

ReactDOM.render(<App />, elem);
